import Vue from "vue";
import Vuex from "vuex";

import cabin from "./modules/cabin";
import cruise from "./modules/cruise";
import basket from "./modules/basket";

Vue.use(Vuex);

export default new Vuex.Store({
    actions: {

    },
    mutations: {

    },
    state: {

    },
    getters: {

    },
    modules: {
        cabin,
        cruise,
        basket
    },
});